import APIClient from '@/shared/http/clients/api'

const resourceName = 'REDataPagamento'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAll = (limit, index, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}?limit=${limit}&index=${index}`, data, config)
const DeleteSolicitacao = (id, data, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/${id}`, data, config)
const AprovarSolicitacao = (id, data, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/aprovar/${id}`, data, config)
const ReprovarSolicitacao = (id, data, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/reprovar/${id}`, data, config)
const GetRequestsByFiltro = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/filtro?limit=${limit}&index=${index}`, data, config)
const getDataPagamento = (id, data, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/getDataPagamento/${id}`, data, config)

const ChangedateofinstallmentRepository = {
  GetAll,
  AprovarSolicitacao,
  ReprovarSolicitacao,
  DeleteSolicitacao,
  GetRequestsByFiltro,
  getDataPagamento
}

export default ChangedateofinstallmentRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/changedateofinstallment.js